import React from "react";
import { 
  MdMessage, MdPhone, MdInventory, MdPayment, MdAnalytics, 
  MdComputer, MdEvent, MdSecurity, MdNotifications, MdLocalShipping,
  MdQrCode, MdCloudUpload, MdApi, MdSync, MdDescription,
  MdPhoneAndroid, MdEmail, MdFax, MdAutoFixHigh
} from "react-icons/md";
import { 
  FaRobot, FaChartLine, FaMobile, FaUsers, FaReceipt, 
  FaFileInvoiceDollar, FaCloudDownloadAlt, FaBell
} from "react-icons/fa";
import { 
  HiOutlineDocumentReport, HiOutlineCreditCard 
} from "react-icons/hi";
import { 
  BiMoney, BiBarcode 
} from "react-icons/bi";

const FeatureCard = ({ feature }) => {
  // 기능 이름에 따른 아이콘 매핑
  const getIconByFeature = (featureName) => {
    const iconMap = {
      // ERP & 공통 기능
      '알림톡&SMS': <MdMessage className="text-blue-500" />,
      'Fax': <MdFax className="text-gray-500" />,
      'Auto Call': <MdPhone className="text-green-500" />,
      '재고자동처리': <MdInventory className="text-orange-500" />,
      '카드결제\n현금영수증': <HiOutlineCreditCard className="text-purple-500" />,
      '정산자동화': <FaChartLine className="text-indigo-500" />,
      '문서 전산화\n리포트출력': <HiOutlineDocumentReport className="text-teal-500" />,
      'PC&모바일': <FaMobile className="text-pink-500" />,
      
      // CRM 기능
      '주문접수&조회': <MdAnalytics className="text-blue-600" />,
      '이벤트 관리': <MdEvent className="text-red-500" />,
      '정산내역조회': <BiMoney className="text-green-600" />,
      '사용자별\n접속권한': <MdSecurity className="text-yellow-600" />,
      '그룹사-계열사\n기능 적용': <FaUsers className="text-cyan-500" />,
      '공지전달': <MdNotifications className="text-orange-600" />,
      '배송현황조회': <MdLocalShipping className="text-blue-700" />,
      
      // SCM 기능
      '발주접수': <FaReceipt className="text-emerald-500" />,
      'QR코드&바코드\n제품출하': <MdQrCode className="text-violet-500" />,
      '배송등록': <MdLocalShipping className="text-blue-600" />,
      '고객관리': <FaUsers className="text-rose-500" />,
      '정산관리': <MdAnalytics className="text-indigo-600" />,
      '세금계산서\n발행': <FaFileInvoiceDollar className="text-amber-600" />,
      '이미지업로드': <MdCloudUpload className="text-sky-500" />,
      
      // 고도화 기능
      'API연동': <MdApi className="text-purple-600" />,
      '기존 데이터\n동기화': <MdSync className="text-cyan-600" />,
      '알림톡': <FaBell className="text-yellow-500" />,
    };
    
    return iconMap[featureName] || <MdAutoFixHigh className="text-rose-600" />;
  };

  return (
    <div className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[120px] md:h-[120px] lg:w-[130px] lg:h-[130px] backdrop-blur-sm bg-white/80 rounded-2xl border border-white/20 
                    hover:bg-white/90 hover:backdrop-blur-md
                    transition-all duration-500 ease-out cursor-pointer group
                    hover:scale-[1.02] hover:-translate-y-2
                    shadow-lg shadow-gray-900/5 hover:shadow-xl hover:shadow-gray-900/10">
      <div className="h-full flex flex-col justify-center items-center p-2 sm:p-3">
        <div className="text-center space-y-2 flex flex-col items-center">
          {/* 미니멀 아이콘 컨테이너 */}
          <div className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 rounded-xl bg-gray-50/60 backdrop-blur-sm border border-gray-100/50
                          flex items-center justify-center
                          group-hover:bg-white/80 group-hover:scale-110 group-hover:rotate-3
                          transition-all duration-500 ease-out
                          group-hover:shadow-lg group-hover:shadow-gray-900/10">
            <div className="flex items-center justify-center w-full h-full">
              <span className="text-base sm:text-lg md:text-xl transition-all duration-500 ease-out 
                             group-hover:scale-110 flex items-center justify-center">
                {getIconByFeature(feature.name)}
              </span>
            </div>
          </div>
          
          {/* 현대적 타이포그래피 */}
          <div className="text-[10px] sm:text-xs md:text-sm text-gray-600 group-hover:text-gray-800 
                          transition-colors duration-300 whitespace-pre-line 
                          leading-tight font-[SUIT-Regular] font-medium text-center
                          group-hover:scale-105 transform transition-transform duration-300">
            {feature.name}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard; 